import { FinancialInsightsSummary } from "../summary/SummaryComponents";

export const CHECKOUT_CONFIGS = {
  FI: {
    summaryComponent: FinancialInsightsSummary,
    breadcrumbs: [
      { label: "Financial Insights", to: "/finances/insights" },
      { label: "Check out" },
    ],
  },

  //   TF: {
  //     summaryComponent: TaxFilingSummary,
  //     breadcrumbs: [
  //       { label: "Tax Filing", to: "/tax-filing" },
  //       { label: "Check out" },
  //     ],
  //   },
};
